module.exports = __webpack_public_path__ + "img/twitter.cf016ff.svg";